
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Tooltip as NCTooltip } from '@platform/base';
export default class EllipsisToTooltip extends Component {
    constructor(props) {
        super(props);
        this.state = { visible: props.visible || false };
    }

    componentWillReceiveProps() {
        let selfDom = ReactDOM.findDOMNode(this).querySelector('.form-card-tooltip-content') || ReactDOM.findDOMNode(this);
        if (selfDom && selfDom.clientWidth < selfDom.scrollWidth) {
            this.setState({ visible: true });
        } else {
            this.setState({ visible: false });
        }
    }

    render() {
        let { children, className, ...other } = this.props;

        return (
            this.state.visible ? (
                <NCTooltip
                    {...other}
                    delay={1}
                    placement="rightBottom"
                    className="form-card-item-tooltip"
                >
                    <span className={`${this.state.visible ? className : ''}`}>{children}</span>
                </NCTooltip>
            ) : children);
    }
}